const tokenGoogleInitialState = {
    tokenGoogle: {
        loading: false,
        error: null,
        data: null
    },
};

export default tokenGoogleInitialState;